import classnames from 'classnames'
import dompurify from 'dompurify'
import moment from 'moment-timezone'
import { PropsWithChildren, FC } from 'react'
import { useSelector } from 'react-redux'
import { PaperClipOutlined } from '@ant-design/icons'
import { adminJobRequestQuery_jobRequest_jobRequestComments as MessageType } from '@OpsQuality/JobRequestDetails/__generated__/adminJobRequestQuery'
import { DATE_TIME_FORMAT } from '@OpsQuality/constants'

import Box from '~/core/Box'
import { getUserIdentity } from '~/redux-modules/identity'
import colors from '~/styles/_colors.css'
import SafeDownloadLink from '~/apps/consumer/components/SafeDownloadLink'

import { extractMessageName } from './logic'
import styles from './styles.css'

type RenderMessagePropsType = {
    key: number
    message: MessageType
}

const FICTIV = 'Fictiv'

const RenderMessage: FC<PropsWithChildren<RenderMessagePropsType>> = props => {
    const { message } = props

    const identity = useSelector(getUserIdentity)

    const messageAuthor = extractMessageName(message, identity.id)
    const sanitizer = dompurify.sanitize

    return (
        <Box
            backgroundColor="white"
            direction="row"
            padding="24px"
            style={{
                borderTop: `solid 1px ${colors.topNavHeaderBorder}`,
            }}
            key={message.id}
        >
            <Box justifyContent="center">
                <span
                    className={classnames(styles.circleBg, {
                        [styles.nonFictivCircle]:
                            messageAuthor.initial !== FICTIV,
                    })}
                >
                    {messageAuthor.initial}
                </span>
            </Box>
            <Box flex={1} direction="col" marginLeft="20px">
                <Box color={colors.success} style={{ fontWeight: 500 }}>
                    {messageAuthor.showAuthorText}
                </Box>
                <Box className={styles.messageInfo} marginBottom="5px">
                    <Box style={{ fontWeight: 500 }}>
                        Subject: {message.subject || ''}
                    </Box>
                    <Box className={styles.dateMessage}>
                        {moment(message.createdAt).format(DATE_TIME_FORMAT)}
                    </Box>
                </Box>
                <div
                    className={styles.messageBody}
                    dangerouslySetInnerHTML={{
                        __html: sanitizer(message.body),
                    }}
                />
                {message.attachments && message.attachments.length > 0 && (
                    <Box direction="col">
                        {message.attachments.map(attachment => (
                            <Box alignItems="center" key={attachment.id}>
                                <PaperClipOutlined
                                    style={{
                                        marginRight: '5px',
                                    }}
                                />
                                <SafeDownloadLink
                                    fileName={attachment.fileName}
                                    downloadUrl={attachment.url}
                                    style={{
                                        marginRight: '5px',
                                    }}
                                >
                                    <div className={styles.messageBody}>
                                        {attachment?.fileName || ''}
                                    </div>
                                </SafeDownloadLink>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default RenderMessage
